// extracted by mini-css-extract-plugin
export default {"footerCancelButton":"_3xWwt","footerEnterButton":"_29raa","iconSuccess":"_1Y8dB","success-icon":"_2nkyc"};